import { jsx } from "react/jsx-runtime";
import { Path, SVG } from "@wordpress/primitives";
var arrow_down_right_default = /* @__PURE__ */ jsx(SVG, { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", children: /* @__PURE__ */ jsx(Path, { d: "M10 18h8v-8h-1.5v5.5L7 6 6 7l9.5 9.5H10V18Z" }) });
export {
  arrow_down_right_default as default
};
//# sourceMappingURL=arrow-down-right.js.map
